export function leagueHelper(initObj, league, data) {
    switch (league) {
        case 'mlb':
            return {
                ...initObj,
                secondaryStatus: data.details.status,
                status:
                    data.details.inning === 0
                        ? 'Pre-Game'
                        : data.details.inning > 0 && data.details.status !== 'Final'
                        ? 'In-Progress'
                        : 'Final',
            }
        case 'nhl':
            return {
                ...initObj,
                secondaryStatus: data.details.status,
                status:
                    (typeof data.details.period === 'undefined' || data.details.period === 0) &&
                    data.details.status !== 'Final'
                        ? 'Pre-Game'
                        : data.details.period > 0 && data.details.status !== 'Final'
                        ? 'In-Progress'
                        : 'Final',
            }
            case 'mls':
            case 'fran':
            case 'liga':
            case 'chlg':
            case 'bund':
            case 'seri':
            case 'bpl':
                return {
                    ...initObj,
                    secondaryStatus: data.details.status,
                    status:
                        (typeof data.details.period === 'undefined' || data.details.period === 0) &&
                        data.details.status !== 'Final'
                            ? 'Pre-Game'
                            : data.details.period > 0 && data.details.status !== 'Final'
                            ? 'In-Progress'
                            : 'Final',
                }
        case 'nba':
            return {
                ...initObj,
                secondaryStatus: data.details.status,
                status:
                    data.details.quarter === 0
                        ? 'Pre-Game'
                        : data.details.quarter > 0 && data.details.status !== 'Final'
                        ? 'In-Progress'
                        : 'Final',
            }
        case 'whc':
        case 'wjc':
            return {
                ...initObj,
                secondaryStatus: data.details.status,
                status:
                    (typeof data.details.period === 'undefined' || data.details.period === 0) &&
                    data.details.status !== 'Final'
                        ? 'Pre-Game'
                        : data.details.period > 0 && data.details.status !== 'Final'
                        ? 'In-Progress'
                        : 'Final',
            }
        default:
            return {}
    }
}
